import {get} from 'lodash';
import * as actionType from './UserSettingsActionsType';
import {SYSTEM_MEASURE} from '../util/SystemMeasure';

const initialState = {
  isLoading: false,
  isLoaded: false,
  isSaving: false,
  isSaved: false,
  isSavingEmailAlert: false,
  isSavedEmaiVideolAlert: false,
  settings: {
    systemMeasure: SYSTEM_MEASURE.IMPERIAL,
    eventVideoAlerts: [],
    notificationId: ''
  }
};

export default function onDemand(state = initialState, action) {
  const type = get(action, 'type');
  switch (type) {
    case actionType.GET_USERSETTINGS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        isSaved: false,
        isSaving: false,
        isSavingEmailAlert: false,
        isSavedEmaiVideolAlert: false
      };
    case actionType.GET_USERSETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        settings: get(action, 'payload', initialState.settings)
      };
    case actionType.GET_USERSETTINGS_FAIL:
      return {
        ...state,
        isLoading: false
      };
    case actionType.UPDATE_USERSETTINGS_REQUEST:
      return {
        ...state,
        isSaving: true,
        isSaved: false
      };
    case actionType.UPDATE_USERSETTINGS_SUCCESS:
      return {
        ...state,
        isSaving: false,
        isSaved: true,
        settings: {
          systemMeasure: get(action, 'payload.systemMeasure')
        }
      };
    case actionType.UPDATE_USERSETTINGS_FAIL:
      return {
        ...state,
        isSaving: false
      };
    case actionType.UPDATE_EMAILALERT_REQUEST:
      return {
        ...state,
        isSavingEmailAlert: true,
        isSavedEmaiVideolAlert: false
      };
    case actionType.UPDATE_EMAILALERT_SUCCESS:
      return {
        ...state,
        isSavingEmailAlert: false,
        isSavedEmaiVideolAlert: true,
        settings: {
          eventVideoAlerts: get(action, 'payload.eventVideoAlerts'),
          notificationId: get(action, 'payload.notificationId')
        }
      };
    case actionType.UPDATE_EMAILALERT_FAIL:
      return {
        ...state,
        isSavingEmailAlert: false
      };
    default:
      return state;
  }
}
